/**
 * Product Collection Carousel - Swiper initialization
 */

function initProductCarousel(sectionId) {
  const element = document.querySelector(`#shopify-section-${sectionId} .product-collection-swiper`);
  if (!element || typeof Swiper === 'undefined') return;

  const swiper = new Swiper(element, {
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
      nextEl: `#shopify-section-${sectionId} .carousel-nav-next`,
      prevEl: `#shopify-section-${sectionId} .carousel-nav-prev`,
    },
    breakpoints: {
      480: { slidesPerView: 2.2 },
      768: { slidesPerView: 3.2 },
      1024: { slidesPerView: 4.2 }
    },
    watchOverflow: true,
    observer: true,
    observeParents: true,
  });

  // Update navigation states
  const updateNav = () => {
    const prevBtn = document.querySelector(`#shopify-section-${sectionId} .carousel-nav-prev`);
    const nextBtn = document.querySelector(`#shopify-section-${sectionId} .carousel-nav-next`);
    if (prevBtn) prevBtn.disabled = swiper.isBeginning;
    if (nextBtn) nextBtn.disabled = swiper.isEnd;
  };

  swiper.on('slideChange', updateNav);
  updateNav();
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.shopify-section--product-collection-carousel').forEach(section => {
    initProductCarousel(section.id.replace('shopify-section-', ''));
  });
});
